'use strict';

var request, resourceUtils;

resourceUtils = require('./resourceUtils.coffee');

request = require('superagent');

module.exports = require('./resource.coffee')(request, null, resourceUtils);